<script>

    import { createEventDispatcher } from 'svelte'

    import UtilsMethods from '../$methods/utils.methods'

    export let hideLabel = false
    export let isDefault = true

    export let provider = ""
    export let service = ""

    if(isDefault) {
        provider = 'Estafeta'
        service = 'Terrestre'
    }

    const dispatch = createEventDispatcher()

    let services = []

    const providers = UtilsMethods.getProviders()
    const servicesList = UtilsMethods.getServices()

    setServices()

    function setServices() {

        if(!provider) {
            service = ''
            return dispatch('change')
        }

        services = servicesList[provider]
        service = isDefault? services[0] : ''

        if(provider && !isDefault)
            service = services[0]

        dispatch('change')
    }

</script>

<!-- svelte-ignore a11y-no-onchange -->
<div class="columns app-providers">
    <div class="column">
        <div class="field app-select-field">
            {#if !hideLabel}
                <label for="" class="label">Proveedor</label>
            {/if}
            <div class="control">
                <div class="select is-fullwidth">
                    <select bind:value={provider} on:change={setServices}>
                        {#if !isDefault}
                            <option value="">Proveedor</option>
                        {/if}
                        {#each providers as providerItem}
                            <option value="{ providerItem }">{ providerItem }</option>
                        {/each}
                    </select>
                </div>
            </div>
        </div>
    </div>
    <div class="column">
        <div class="field app-select-field">
            {#if !hideLabel}
                <label for="" class="label">Servicio</label>
            {/if}
            <div class="control">
                <div class="select is-fullwidth">
                    <select bind:value={service} on:change={() => dispatch('change')}>
                        {#if !isDefault}
                            <option value="">Servicio</option>
                        {/if}
                        {#each services as serviceItem}
                            <option value="{ serviceItem }">{ serviceItem }</option>
                        {/each}
                    </select>
                </div>
            </div>
        </div>
    </div>
</div>

<style>
    .app-providers .column {
        min-width: 0;
    }

    .app-select-field {
        width: 100%;
        min-width: 0;
    }

    .app-select-field .control {
        width: 100%;
    }
</style>